// import { initializeBugReporting } from "./bugReporting";
import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import "./styles/fonts.css";
import App from "./App";
import { unregister } from "./registerServiceWorker";

// initializeBugReporting();

ReactDOM.render(<App />, document.getElementById("root"));
unregister();



// WEBPACK FOOTER //
// ./src/index.js